
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

interface PhotoUploadSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  uploadCount: number;
}

export const PhotoUploadSuccessModal = ({ 
  isOpen, 
  onClose, 
  uploadCount 
}: PhotoUploadSuccessModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-carbon border border-ice-white/20 shadow-toxic-green max-w-md mx-auto" style={{ background: '#121212', opacity: '1' }}>
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="w-16 h-16 text-toxic-green animate-scale-in" />
          </div>
          <DialogTitle className="text-xl font-semibold text-ice-white mb-2">
            Photo Uploaded Successfully!
          </DialogTitle>
          <DialogDescription className="text-ice-white/70">
            {uploadCount === 1 
              ? "Your photo has been added to your profile after enhanced validation."
              : `${uploadCount} photos have been added to your profile after enhanced validation.`
            }
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex justify-center mt-6">
          <Button 
            onClick={onClose}
            className="bg-toxic-green hover:bg-toxic-green/80 text-carbon font-medium px-8 py-2 glow-toxic-green"
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
